import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PortalRoutes from "../../routes/PortalRoutes";
import Footer from "./Footer";
import InactivityWarningModal from "../modals/InactivityWarningModal";
import useInactivityTimer from "../../hooks/useInactivityTimer";
import menuList from "../../config/sideBarMenu";
import { createBrowserHistory } from "history";

// Add CSS for persistent countdown
const persistentCountdownStyle = {
  position: "fixed",
  top: 20,
  right: 30,
  zIndex: 2000,
  background: "rgba(0,0,0,0.7)",
  color: "#fff",
  padding: "8px 18px",
  borderRadius: "24px",
  fontSize: 18,
  fontWeight: 600,
  letterSpacing: 1,
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  pointerEvents: "none",
};

export default function PageLayout() {
  const history = createBrowserHistory();

  // Initialize inactivity timer (12 minutes warning, 15 minutes logout)
  const { showWarning, remainingTime, formatTime, resetTimers } =
    useInactivityTimer(
      12 * 60 * 1000, // 12 minutes
      15 * 60 * 1000, // 15 minutes
    );

  return (
    <div className="">
      <Sidebar history={history} menuList={menuList} />
      <div className="portal">
        <Header navList={["Home", "Notification", "Set Reminder"]} />
        <div className="content main-content">
          <PortalRoutes />
        </div>
        <Footer />
      </div>

      {/* Persistent Countdown Timer */}
      {/* <div style={persistentCountdownStyle}>
        Session Timeout: {formatTime(remainingTime)}
      </div> */}

      {/* Inactivity Warning Modal */}
      {showWarning && (
        <InactivityWarningModal
          remainingTime={remainingTime}
          formatTime={formatTime}
          onStayLoggedIn={resetTimers}
        />
      )}
    </div>
  );
}
